<div class="circle-overlay"><div class="theme-radio-off"></div></div>
<div class="linear-bet-builder-selection-display__content-wrapper">
    <div class="linear-bet-builder-selection-display__content">
        <div class="linear-bet-builder-selection-display__name">
            {{ selection.name }}
            @if (!!selection.details && inlineDetails) {
                <span class="linear-bet-builder-selection-display__inline-details">- {{ selection.details }}</span>
            }
            @if (!!selection.hasWarning) {
                <span class="theme-warning"></span>
            }
        </div>

        @if (!!selection.details && !inlineDetails) {
            <div class="linear-bet-builder-selection-display__details">{{ selection.details }}</div>
        }
    </div>

    @if (signpostingText) {
        <div class="marketsubtype-signposting content-alignment">{{ signpostingText }}</div>
    }

    @if (!!selection.oddsState) {
        @switch (selection.oddsState) {
            @case (pickOddsState.Locked) {
                <div class="lock-icon content-alignment" [ngClass]="isEpcotEnabled ? 'theme-lock' : 'theme-locked-i'"></div>
            }
            @case (pickOddsState.Closed) {
                <div class="closed closed-message">{{ closedMessage }}</div>
            }
        }
    }
</div>
